import { render, staticRenderFns } from "./AttachmentUploader.vue?vue&type=template&id=05359e52&scoped=true"
import script from "./AttachmentUploader.vue?vue&type=script&lang=ts"
export * from "./AttachmentUploader.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentUploader.vue?vue&type=style&index=0&id=05359e52&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05359e52",
  null
  
)

export default component.exports